import { Component, EventEmitter, Output } from '@angular/core';
import { IconComponent } from '@navstation-portal/shared/ui/components';
import { IconNames } from '@navstation-portal/shared/data-model/ui';

@Component({
  selector: 're-trash-button',
  templateUrl: './trash-button.component.html',
  styleUrl: './trash-button.component.css',
  imports: [IconComponent],
})
export class TrashButtonComponent {
  IconNames = IconNames;

  @Output() delete = new EventEmitter<any>();

  onDelete() {
    this.delete.emit();
  }
}
